"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWithText = IconWithText;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _logging = require("../../logging.js");
var _Container = require("./Container.js");
var _excluded = ["icon", "iconSize", "size", "semanticColor", "children", "color", "align", "spacer", "rightAlign"];
/**
 * This component allows you easily place an icon and text together.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-iconwithtext--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon#pairing-with-text) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/IconWithText) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=321-0&t=SlcSOGwMfUq5fUJD-1)
 */
function IconWithText(_ref) {
  var icon = _ref.icon,
    iconSize = _ref.iconSize,
    size = _ref.size,
    semanticColor = _ref.semanticColor,
    children = _ref.children,
    color = _ref.color,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    spacer = _ref.spacer,
    rightAlign = _ref.rightAlign,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (rightAlign) {
    (0, _logging.renamedPropWarning)('rightAlign', 'IconWithText', 'align="end"');
  }
  var Icon = icon;
  var renamedAlign = rightAlign ? 'end' : align;
  return /*#__PURE__*/_react["default"].createElement(_Container.Container, Object.assign({
    $semanticColor: semanticColor,
    $spacer: spacer,
    $align: renamedAlign
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.IconWithText
  }), children, Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
    semanticColor: semanticColor,
    iconSize: iconSize,
    size: size,
    "aria-hidden": "true"
  }));
}